import { SUSPENSE_TIMEOUT } from 'constants/keys'
import { useAuth } from 'contexts/auth'
import { useIdleTimer } from 'react-idle-timer'

const usePageVisibilityWithTimeout = () => {
  const { signOut } = useAuth()

  useIdleTimer({
    timeout: SUSPENSE_TIMEOUT,
    onIdle: () => {
      signOut()
      window.location.reload()
    },
  })

  // const [isVisible, setIsVisible] = useState<boolean>(document.visibilityState === 'visible')

  // const checkInactivityTimeout = () => {
  //   const lastActivity = localStorage.getItem(LAST_ACTIVITY_KEY)

  //   if (lastActivity) {
  //     const timeSinceLastActivity = Date.now() - parseInt(lastActivity, 10)

  //     if (timeSinceLastActivity > SUSPENSE_TIMEOUT) {
  //       signOut()
  //     }
  //   }
  // }

  // const updateLastActivity = () => {
  //   localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString())
  // }

  // const handleVisibilityChange = (timeoutId: NodeJS.Timeout) => {
  //   if (document.visibilityState === 'visible') {
  //     setIsVisible(true)

  //     if (timeoutId) {
  //       clearTimeout(timeoutId)
  //     }

  //     checkInactivityTimeout()
  //   } else {
  //     setIsVisible(false)
  //     updateLastActivity()

  //     timeoutId = setTimeout(() => {
  //       signOut()
  //       window.location.reload()
  //     }, SUSPENSE_TIMEOUT)
  //   }
  // }

  // useEffect(() => {
  //   let timeoutId: NodeJS.Timeout

  //   document.addEventListener('visibilitychange', () => handleVisibilityChange(timeoutId))

  //   checkInactivityTimeout()

  //   return () => {
  //     document.removeEventListener('visibilitychange', () => handleVisibilityChange(timeoutId))

  //     if (timeoutId) {
  //       clearTimeout(timeoutId)
  //     }
  //   }
  // }, [signOut])

  // return isVisible
}

export default usePageVisibilityWithTimeout
